<template lang="pug">
#store.equipment-tech-map
  .spinner-container.form-spinner(v-if="loading")
    q-spinner(color="primary", size="3em")

  .tech-map-card(v-if="!loading")
    .main-block
      .actions-block
        .show-card-actions
          div(
            v-for="button in buttons",
            :key="button.name",
            :class="`button-wrapper ${button.name}`",
            :style="getButtonStyle(button)"
          )
            q-btn.show-card-action(
              flat,
              no-caps,
              @click="updateButtonStyle(button)",
              :style="getButtonStyle(button)",
              v-if="button.name !== 'import'"
            )
              template(v-if="ifButtonIconExists(button)", slot="default")
                inline-svg(:class="[`${button.name}-icon`]", :style="button.style.icon", :src="getButtonIcon(button)")
              template(v-if="ifButtonLabelExists(button)", slot="default")
                span.action-label {{ button.label }}
            q-btn.materials-import-button(v-else, @click="openImportForm()", flat, no-caps)
              template(slot="default")
                inline-svg.grid-btn-icon-left(:src="require(`../../../../../assets/icons/header/file.svg`)")
              template(slot="default")
                span {{ button.label }}

    .techmap-info-blocks
      .spinner-container.form-spinner(v-if="loadingBlocks")
        q-spinner(color="primary", size="3em")

      .specification-block(v-if="!loadingBlocks")
        specification(
          ref="specificationRef",
          :editable="editable",
          :tableData="tableData",
          :columns="columns",
          :hasNextPage="hasNextPage",
          @change-item="editDataItem",
          @search-or-sort="reloadTable",
          @load-more="loadMore"
        )

    .button-group.row.justify-center(v-if="editable")
      q-btn.tech-map-form-submit(flat, no-caps, :label="submitButton", @click="onSubmit")
  grid-modals(ref="gridModalsRef", @reload-data="resetFilters", :parentData="{ grid: grid, path: workListPath }")
</template>

<script setup>
import specification from "../../specification/specification";
import ImportExcelForm from "@/components/shared/forms/importExcelForm";
import gridModals from "@/components/shared/grid/gridModals";
import { handleError } from "@/services/handleErrors";
import { Notify } from "quasar";
import backend from "@/api";
import { notifies } from "@/services/useLocales";
import { ref, onMounted } from "vue";

const props = defineProps({
  /* Дата от родителя. Пример:
  {
    "data": {
        "titles": {
            "works_list": "Список работ"
        },
        "tabs": [
            {
                "name": "works_list",
                "icon": "",
                "label": "Список работ"
            }
        ]
    },
    "path": "/api/v3/work_groups",
    "grid": "work_groups",
    "grid_key": "data",
    "row": {
        "id": 418,
        "title": "рг без работ",
        "facility_title": "ООО Эталон",
        "group_head_name": "Wade Mante пппрппп Gulgowski",
        "created_at": "2025-09-29T09:58:31.861Z",
        "updated_at": "2025-09-29T09:58:31.861Z",
        "default_executor": null
    },
    "row_id": 418,
    "tab_name": "tech_map",
    "loading": false
  }
  */
  parentData: { type: Object, default: () => {} },
});

const { grid } = props.parentData;
const { path } = props.parentData;
const { row } = props.parentData;
const rowId = props.parentData.row_id;
const tabName = props.parentData.tab_name;
const perPage = 20;
const workListPath = `${path}/${rowId}/works`;

const tableData = ref([]);
const buttons = ref([]);
const columns = ref([]);
const editable = ref(false);
const loading = ref(true);
const loadingBlocks = ref(true);
const submitButton = ref("");
const sortParams = ref({});
const page = ref(1);
const hasNextPage = ref(false);

const gridModalsRef = ref(null);
const specificationRef = ref(null);

const editDataItem = attr => {
  const { val, index, name } = attr;
  tableData.value[index][name] = val;
};

const getButtonStyle = button => {
  return button?.style?.wrapper ?? {};
};

const getButtonIcon = button => {
  return require(`../../../../../assets/icons/ppr/equipment/show/actions/${button.icon}`);
};

const ifButtonIconExists = button => {
  return button.icon && button.icon.length > 0;
};

const ifButtonLabelExists = button => {
  return button.label && button.label.length > 0;
};

const updateButtonStyle = button => {
  if (button.onclick?.child) {
    buttons.value.find(b => b.name === button.name).style.wrapper.display = "none";
    buttons.value.find(b => b.name === button.onclick.child).style.wrapper.display = "initial";
  } else if (button.onclick && button.onclick.parent) {
    buttons.value.find(b => b.name === button.name).style.wrapper.display = "none";
    buttons.value.find(b => b.name === button.onclick.parent).style.wrapper.display = "initial";
  }

  if (button.onclick?.fn_name && button.onclick.fn_name == "setEditable") {
    setEditable(button.onclick?.attr);
  }
};

const setEditable = attr => {
  editable.value = attr.value;
};

const onSubmit = async (params = {}) => {
  const submitPath = `${workListPath}/update_records`;
  const backButton = buttons.value.find(item => item.name === "back");

  params = {
    works: [],
  };

  tableData.value.forEach(item => params.works.push(item));

  try {
    await backend.update(submitPath, "", params);

    Notify.create(notifies.value.success_updated_entry);
  } catch (err) {
    await handleError(err);
  } finally {
    editable.value = false;
    updateButtonStyle(backButton);
  }
};

const reloadTable = async params => {
  page.value = 1;
  hasNextPage.value = false;
  tableData.value = [];
  if (params) {
    sortParams.value = {
      sort_direction: params.sortDirection,
      sort_by: params.sort,
      query: params.search,
    };
  } else {
    sortParams.value = {};
  }
  await loadData();
};

const resetFilters = () => {
  loading.value = false;
  loadingBlocks.value = false;
  sortParams.value = {};
  specificationRef.value?.resetFilters?.();
};

const loadData = async () => {
  const paginationParams = {
    page: page.value,
  };
  const params = { ...sortParams.value, ...paginationParams };

  try {
    const { data } = await backend.index(workListPath, { params });

    tableData.value = [...tableData.value, ...data.data];

    if (Number(data.pagination.page) === 1) {
      buttons.value = data.actions?.crud;
      columns.value = data.columns;
      submitButton.value = data.actions?.submit?.label;
    }

    if (data.count > perPage * page.value) {
      hasNextPage.value = true;
      page.value++;
    } else {
      hasNextPage.value = false;
    }
  } catch (err) {
    await handleError(err);
  } finally {
    loading.value = false;
    loadingBlocks.value = false;
  }
};

const openImportForm = () => {
  gridModalsRef.value?.openImportForm?.({ data: [], href: "" });
};

const loadMore = async () => {
  await loadData();
};

onMounted(async () => {
  await loadData();
});
</script>

<style lang="scss">
#store .techmap-info-blocks,
#store .equipment-tech-map,
#store .tabs-block {
  min-height: 0;
}

#store {
  .actions-block {
    padding: 0 !important;
  }

  .specification-title span {
    font-size: 20px !important;
    color: var(--tab-text-color) !important;
  }

  &.equipment-tech-map .tech-map-card .specification-block {
    margin-top: 58px;
  }
  .equipment-tech-map {
    position: relative;
    border-bottom: var(--tabs-block-td-border) !important;
    border-right: var(--tabs-block-td-border) !important;
    .tech-map-card {
      .tabs-block {
        max-height: calc(66vh - 100px);
        margin-top: 0;
        td {
          padding: 10px;
        }
        thead {
          position: absolute;
          display: table;
          table-layout: fixed;
          top: -40px;
        }
        tr {
          display: table;
          table-layout: fixed;
          width: 100%;
        }
      }
    }
  }

  .show-card-actions {
    .q-btn__wrapper {
      .q-btn__content {
        display: flex;
        flex-flow: row nowrap;
        width: 100%;

        span.action-label {
          margin: 0;
        }

        svg {
          min-width: 12px;
        }
      }
    }

    .materials-import-button {
      padding-left: 15px;
      padding-right: 15px;
      margin-left: 10px;
      border-radius: 8px;
      background-color: #5b7aff;

      span {
        color: #fff;
      }
    }
  }
}

#components-table.stores td {
  color: var(--tab-text-color);
}
</style>
